module.exports = __webpack_public_path__ + "static/img/040901.a0f6f356.png";